import { Box, Flex, Input, Text } from '@chakra-ui/react';

export default function BottleItem({
  value,
  isEdit,
  onChange,
  bottleIndex,
  error,
}) {
  const parts =
    typeof value === 'string'
      ? value.split('+').map((v) => v.trim())
      : [value?.R1 || '', value?.R2 || '', value?.E || ''];

  const inputs = [parts[0] || '', parts[1] || '', parts[2] || ''];

  const isR1Required = [1].includes(bottleIndex);

  const isBottle1 = bottleIndex === 1;
  const showR1Error = isEdit && isBottle1 && !inputs[0]?.trim();

  if (!isEdit) {
    return (
      <Text fontWeight="bold">{inputs.filter(Boolean).join(' + ') || '—'}</Text>
    );
  }

  return (
    <Flex gap={3} w="100%">
      {/* R1 */}
      <Box flex="1">
        <Text fontSize="xs" fontWeight="semibold" mb={1}>
          R1
          {isR1Required && (
            <Text as="span" color="red.500" ml={1}>
              *
            </Text>
          )}
        </Text>

        <Input
          size="sm"
          value={inputs[0]}
          onChange={(e) => onChange(0, e.target.value)}
          isInvalid={showR1Error}
        />

        {showR1Error && (
          <Text fontSize="xs" color="red.500" mt={1}>
            R1 is required for Bottle 1
          </Text>
        )}
      </Box>

      <Text mt={6} fontWeight="bold" color="gray.500">
        +
      </Text>

      {/* R2 */}
      <Box flex="1">
        <Text fontSize="xs" fontWeight="semibold" mb={1}>
          R2
        </Text>
        <Input
          size="sm"
          value={inputs[1]}
          onChange={(e) => onChange(1, e.target.value)}
        />
      </Box>

      <Text mt={6} fontWeight="bold" color="gray.500">
        +
      </Text>

      {/* E */}
      <Box flex="1">
        <Text fontSize="xs" fontWeight="semibold" mb={1}>
          E
        </Text>
        <Input
          size="sm"
          value={inputs[2]}
          onChange={(e) => onChange(2, e.target.value)}
        />
      </Box>
    </Flex>
  );
}
